// extracted by mini-css-extract-plugin
export default {"gdprBox":"TryPermoniqSection_gdprBox__jewKV"};